module.exports = __webpack_public_path__ + "img/checkmark_normal.435c942c.svg";